import { useState } from "react";
import { useAuth, authErrorMessage } from "../context/AuthContext";
import { Avatar, AvatarPicker } from "./ui";
import { LegalNotice } from "./AuthModal";
import { useI18n } from "../i18n";

// Lets someone jump in without an account. Guests get a nickname + avatar
// but no friend code, friends or saved XP.
export default function GuestForm({ onDone, cta }) {
  const { t, tx } = useI18n();
  const { guest, playAsGuest, openAuth } = useAuth();
  const [name, setName] = useState(guest.name || "");
  const [avatar, setAvatar] = useState(guest.avatar);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (name.trim().length < 2) return setError(t("Nickname needs at least 2 characters."));
    setBusy(true);
    setError("");
    try {
      await playAsGuest(name, avatar);
      onDone?.();
    } catch (err) {
      setError(authErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="guest-form" onSubmit={submit}>
      <div className="guest-form-top">
        <Avatar avatar={avatar} size={72} />
        <label className="field grow">
          {t("Nickname")}
          <input value={name} onChange={(e) => setName(e.target.value)} maxLength={20} placeholder={t("Sneaky Llama")} autoFocus />
        </label>
      </div>
      <AvatarPicker value={avatar} onChange={setAvatar} />
      {error && <p className="form-error">{error}</p>}
      <button className="btn btn-primary btn-lg btn-block" disabled={busy}>
        {busy ? t("Joining…") : cta || t("Let's play!")}
      </button>
      <LegalNotice action="playing" />
      <p className="muted center small">
        {tx(
          "Want XP, a friend code and invites? <signup>Create an account</signup> or <signin>sign in</signin>.",
          {},
          {
            signup: (c, k) => (
              <button key={k} type="button" className="link" onClick={() => openAuth("signup")}>
                {c}
              </button>
            ),
            signin: (c, k) => (
              <button key={k} type="button" className="link" onClick={() => openAuth("signin")}>
                {c}
              </button>
            ),
          }
        )}
      </p>
    </form>
  );
}
